import {
  GLOBAL_KEYWORD_CHANGE,
  GLOBAL_USER_TOKEN_CHANGE,
  GLOBAL_REMOVE_AUTH,
  GLOBAL_USER_FEATURE_CHANGE,
  GLOBAL_MODULE_ID_CHANGE,
  GLOBAL_MODULE_OBJECT_CHANGE,
  GLOBAL_MODULES_LIST_CHANGE,
} from "../../actions/types";

import jwtDecode from "jwt-decode";

//CHECK FOR TOKEN
let token = localStorage.getItem("token");
let isLoggedIn = false;

if (token == "null" || !token) {
  isLoggedIn = false;
  token = null;
} else {
  isLoggedIn = true;
  token = token;
}

/**
 * condition to check if token is expired
 */
if (token && jwtDecode(token).exp < Date.now() / 1000) {
  isLoggedIn = false,
  token = null;
  localStorage.setItem("token", null);
  window.location.reload();
}

const initialState = {
  keyword: "",
  isLoggedIn: isLoggedIn,
  token: token,
  features: [],
  moduleId: "HOME",
  modules: [],
  moduleObject: {},
};

const setKeyword = (state, action) => {
  let keyword = action.payload.keyword;
  return {
    ...state,
    keyword,
  };
};

const setToken = (state, action) => {
  let token = action.payload.token ? action.payload.token : null;
  let isLoggedIn = action.payload.token ? true : false;

  return {
    ...state,
    token,
    isLoggedIn: isLoggedIn,
  };
};

const setUserFeatures = (state, action) => {
  let features = action.payload.features || [];
  features = features.map((l) => l.feature);
  return {
    ...state,
    features,
  };
};

const setModuleId = (state, action) => {
  let moduleId = action.payload.moduleId || "";
  return {
    ...state,
    moduleId,
  };
};

const setModule = (state, action) => {
  let { moduleObject = {} } = action.payload;
  return {
    ...state,
    moduleObject,
  };
};

const setModulesList = (state, action) => {
  let { modulesList = [] } = action.payload;
  return {
    ...state,
    modulesList,
  };
};

const removeAuth = (state, action) => {
  return {
    ...state,
    isLoggedIn: false,
    token: null,
  };
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GLOBAL_KEYWORD_CHANGE:
      return setKeyword(state, action);

    case GLOBAL_USER_TOKEN_CHANGE:
      return setToken(state, action);

    case GLOBAL_REMOVE_AUTH:
      return removeAuth(state, action);

    case GLOBAL_USER_FEATURE_CHANGE:
      return setUserFeatures(state, action);

    case GLOBAL_MODULE_ID_CHANGE:
      return setModuleId(state, action);

    case GLOBAL_MODULE_OBJECT_CHANGE:
      return setModule(state, action);

    case GLOBAL_MODULES_LIST_CHANGE:
      return setModulesList(state, action);

    default:
      return state;
  }
};
